import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useProblem(slug) {
  const [problem, setProblem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  useEffect(() => {
    if (!slug) return;
    supabase.from('problems').select('*').eq('slug', slug).single()
      .then(({ data, error }) => {
        if (error) setError(error.message);
        else setProblem(data);
        setLoading(false);
      });
  }, [slug]);
  return { problem, loading, error };
}
